export default __webpack_public_path__ + "static/media/winner_bg.20ceaa58.png";